import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'react-i18next';

export const MyHelmet = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <Helmet>
      <html lang={currentLanguage.slice(0, 2)} />
      <title>{t('HELMET.CHANNELS.TITLE')}</title>
      <meta name="description" content={t('HELMET.CHANNELS.DESCRIPTION')} />
      <link rel="canonical" href="https://www.slex.tv/channels" />

      {/* Twitter */}
      <meta name="twitter:title" content={t('HELMET.CHANNELS.TITLE')} />
      <meta
        name="twitter:description"
        content={t('HELMET.CHANNELS.DESCRIPTION')}
      />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={t('HELMET.CHANNELS.TITLE')} />
      <meta
        property="og:description"
        content={t('HELMET.CHANNELS.DESCRIPTION')}
      />
      <meta property="og:url" content="https://www.slex.tv/channels" />
    </Helmet>
  );
};
